exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2HfFRc_yvi4WSAGIyTYlH0 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n}\n\n._3bZHD969yo8oZyxBdfU_ni {\n  font-size: var(--font-size-normal);\n  color: var(--secondary-text-color);\n  margin: 0;\n}\n\n._3r_tJQFAIghnaUJoqiIhnZ {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n._9wJ7aJjg6-OPn3a20OjpI {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background-color: var(--background-color);\n  flex: 1;\n  min-height: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_2HfFRc_yvi4WSAGIyTYlH0",
	"subtitle": "_3bZHD969yo8oZyxBdfU_ni",
	"header": "_3r_tJQFAIghnaUJoqiIhnZ",
	"content": "_9wJ7aJjg6-OPn3a20OjpI"
};